<picture>
	<source media="(max-width:576px)" [srcset]="urls.get('xs')">
	<source media="(max-width:768px)" [srcset]="urls.get('sm')">
	<source media="(max-width:992px)" [srcset]="urls.get('md')">
	<source media="max-width:1200px)" [srcset]="urls.get('lg')">
	<img [src]="urls.get('xl')" alt="alt" [class]="HostClasses">
</picture>
